/**
 * Devices
 * Devices
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 0 = Equals, 1 = NotEquals, 2 = GreaterThan, 3 = GreaterThanOrEqual, 4 = LessThan, 5 = LessThanOrEqual, 6 = Between, 7 = In, 8 = NotIn, 9 = Contains, 10 = ContainsAny, 11 = DoesNotContain, 12 = StartsWith, 13 = EndsWith, 14 = MatchesWildcard, 15 = DoesNotMatchWildcard, 16 = Exists, 17 = NotExists, 18 = IsTrue, 19 = IsFalse
 */
export enum FilterComparison {
    Equals = 'equals',
    NotEquals = 'notequals',
    GreaterThan = 'greaterthan',
    GreaterThanOrEqual = 'greaterthanorequal',
    LessThan = 'lessthan',
    LessThanOrEqual = 'lessthanorequal',
    Between = 'between',
    In = 'in',
    NotIn = 'notin',
    Contains = 'contains',
    ContainsAny = 'containsany',
    DoesNotContain = 'doesnotcontain',
    StartsWith = 'startswith',
    EndsWith = 'endswith',
    MatchesWildcard = 'matcheswildcard',
    DoesNotMatchWildcard = 'doesnotmatchwildcard',
    Exists = 'exists',
    NotExists = 'notexists',
    IsTrue = 'istrue',
    IsFalse = 'isfalse'
}

